exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hitCounter {\n    left: 5px;\n    margin-top: 15px;\n    position: absolute;\n    z-index: 999;\n}", ""]);

